// This file was automatically generated from app.settings.docTags.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.settings.docTags');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appshared.docTags');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.docTags.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h1 class="el8PageTitle">Document Tags</h1><div class="doc-tags-section"><div><div class="el8InlineBlock w22 padv10 el8StrongMiniHeading">Label</div><div class="el8InlineBlock w37 padv10 el8StrongMiniHeading">Description</div><div class="el8InlineBlock w15 padv10 el8StrongMiniHeading">Code</div><div class="el8InlineBlock w12 padv10 el8StrongMiniHeading">Type</div></div><ul class="doc-tags-list el8SettingsTable el8Loading ebs-list-unstyled"></ul><button class="add-trigger ebs-btn ebs-btn-default">+ Add Document Tag</button></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.docTags.list = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var docTagList6945 = opt_data.docTags;
  var docTagListLen6945 = docTagList6945.length;
  for (var docTagIndex6945 = 0; docTagIndex6945 < docTagListLen6945; docTagIndex6945++) {
    var docTagData6945 = docTagList6945[docTagIndex6945];
    output.append('<li class="curated-list-item el8SettingsTableRow" data-id="', soy.$$escapeHtml(docTagData6945.id), '"><div class="w22 el8SettingsTableCell"><p class="padv10h5" style=\'word-break: break-word\'>');
    el8.template.appshared.docTags.docTag({tag: docTagData6945}, output);
    output.append('</p></div><div class="w37 el8SettingsTableCell"><p class="padv10h5">', soy.$$escapeHtml(docTagData6945.description), '</p></div><div class="w15 el8SettingsTableCell"><p class="padv10h5">', soy.$$escapeHtml(docTagData6945.code), '</p></div><div class="w12 el8SettingsTableCell"><p class="padv10h5">', soy.$$escapeHtml(docTagData6945.codeType), '</p></div><div class="w13 el8SettingsTableCell">', (opt_data.isPracticeAdmin && ! docTagData6945.isShared) ? '<div class="padv10 el8AlignRight"><a class="edit-trigger el8Link">edit</a><a class="remove-trigger el8Link ml10">remove</a></div>' : '', '</div></li>');
  }
  output.append('<li class="new-form-stub"></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.docTags.form = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form class="el8SettingsInlineForm"><ul class="pad5 ebs-list-unstyled"><li><div class="w22 el8SettingsTableCell"><div class="w90"><input type="text" class="el8EditorTextareaWrap ebs-form-control" name="value" /></div></div><div class="w37 el8SettingsTableCell"><div class="w90"><input type="text" class="el8EditorTextareaWrap ebs-form-control" name="description" /></div></div><div class="w15 el8SettingsTableCell"><div class="w90"><input type="text" class="el8EditorTextareaWrap ebs-form-control" name="code" /></div></div><!-- make this a bit longer than above --><div class="w20 el8SettingsTableCell mt2 ml5"><select class="doc-tags-codetypes" name="codeType"><option value="">--</option>');
  var ctList6966 = opt_data.codeTypes;
  var ctListLen6966 = ctList6966.length;
  for (var ctIndex6966 = 0; ctIndex6966 < ctListLen6966; ctIndex6966++) {
    var ctData6966 = ctList6966[ctIndex6966];
    output.append('<option value="', soy.$$escapeHtml(ctData6966), '">', soy.$$escapeHtml(ctData6966), '</div></option>');
  }
  output.append('</select></div></li></ul><div class="el8InlineBlock form-buttons"></div></form>');
  if (!opt_sb) return output.toString();
};
